
export default function EmpathySection() {
  const problems = [
    {
      icon: 'ri-chat-delete-line',
      title: '메시지를 보내도 답장이 없어요',
      description: '당신이 보낸 메시지, 그녀가 보면 귀찮다고 생각할 수도 있는데요?',
      image: 'https://public.readdy.ai/ai/img_res/bb19af9d1474371f913386a2a2561228.jpg'
    },
    {
      icon: 'ri-emotion-unhappy-line',
      title: '문화차이때문에 오해가 생겨요',
      description: '당신이 잘 된다고 한 행동이 일본인 여성을 오해시키거나 불쾌하게 하고 있을지도 모릅니다.',
      image: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20misunderstanding%20conversation%2C%20cultural%20miscommunication%20scene%2C%20one%20Korean%20man%20and%20one%20Japanese%20woman%2C%20confused%20expressions%2C%20modern%20setting%2C%20relationship%20counseling%20context&width=400&height=300&seq=problem-2&orientation=landscape'
    },
    {
      icon: 'ri-question-mark',
      title: '일본여성의 마음을 모르겠어요',
      description: '일본인여성의 여성의 사고, 습관에 공감해야 합니다. 하지만 그녀들의 머릿속을 모르면 어려워요.',
      image: 'https://readdy.ai/api/search-image?query=Korean%20man%20looking%20thoughtful%20and%20confused%2C%20thinking%20about%20Japanese%20culture%20and%20relationships%2C%20question%20marks%20floating%20around%20his%20head%2C%20modern%20lifestyle%20setting%2C%20contemplative%20mood&width=400&height=300&seq=problem-3&orientation=landscape'
    },
    {
      icon: 'ri-calendar-2-line',
      title: '데이트제안을 어떻게 해야할지 모르겠어요',
      description: '데이트신청을 하는데도 본심을 드러내지 않는 일본인여성에 대해 최선의 타이밍이나 권유방법을 모를 때가 많지 않습니까?',
      image: 'https://readdy.ai/api/search-image?query=Korean%20man%20nervously%20preparing%20to%20ask%20someone%20on%20a%20date%2C%20holding%20phone%2C%20anxious%20expression%2C%20modern%20urban%20background%2C%20relationship%20anxiety%20concept%2C%20realistic%20style&width=400&height=300&seq=problem-4&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            이런 고민때문에 힘드시죠?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            일본인여성과의 연애에서 겪는 어려움<br />
            <span className="text-blue-600 font-semibold">당신만의문제가 아닙니다</span>
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {problems.map((problem, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${problem.icon} text-2xl text-red-600`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {problem.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {problem.description}
                  </p>
                </div>
              </div>
              
              <div className="mt-6">
                <img 
                  src={problem.image}
                  alt={problem.title}
                  className="w-full h-48 object-cover object-top rounded-xl"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              이런 문제의 원인은 모두<span className="text-blue-600">"전략 없이 본심을 모르고 행동하고 있기 때문"</span>
            </h3>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              단순히 일본어를 잘하거나 매력적이면 되는게 아닙니다.<br />
              일본인여성의 <span className="font-semibold text-blue-600">심리와 문화적배경을 이해</span>하고<br />
              <span className="font-semibold text-blue-600">상황에 맞는 소통전략</span>이 필요합니다.
            </p>
            
            <div className="mt-8 inline-flex items-center bg-white rounded-full px-6 py-3 shadow-md">
              <i className="ri-lightbulb-line text-2xl text-yellow-500 mr-3"></i>
              <span className="text-lg font-semibold text-gray-7   00">
                바로 이부분에서 저희가 도움을 드릴 수 있습니다
              </span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
